import React from 'react';

import { SVGComponentProps } from './svg.types';

const MultipleChoiceSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherSvgProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
      <rect x="12" y="8.66699" width="9.33333" height="1.33333" fill={fill} />
      <rect x="12" y="11.3336" width="9.33333" height="1.33333" fill={fill} />
      <rect x="12" y="14.0003" width="6.66667" height="1.33333" fill={fill} />
      <rect
        x="3.0013"
        y="9.00033"
        width="6"
        height="6"
        rx="0.333333"
        stroke="#55585E"
        strokeWidth="0.666667"
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
    </svg>
  );
};

export default MultipleChoiceSVG;
